/**
 * @module features/devices/components/TelemetryDashboardSkeleton
 * @description Geometry-matched skeleton for the telemetry page: same grid, card
 * heights and breakpoints as the loaded layout so CLS stays 0.00.
 */
import { Skeleton } from "@/components/ui/skeleton";

export const GAUGE_CARD_HEIGHT = "h-[196px]";
export const CHART_CARD_HEIGHT = "h-[220px]";
export const LOG_PANEL_HEIGHT = "h-[420px]";

export function TelemetryDashboardSkeleton() {
  return (
    <div className="space-y-4" aria-busy="true" aria-label="Loading telemetry" data-testid="telemetry-skeleton">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} className={`${GAUGE_CARD_HEIGHT} rounded-xl`} />
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {[1, 2].map((i) => (
          <Skeleton key={i} className={`${CHART_CARD_HEIGHT} rounded-xl`} />
        ))}
        <Skeleton className={`${CHART_CARD_HEIGHT} rounded-xl lg:col-span-2`} />
      </div>
      <Skeleton className={`${LOG_PANEL_HEIGHT} rounded-xl`} />
    </div>
  );
}
